module.exports = __webpack_public_path__ + "img/9788936456320.bd73ef86.jpg";